import { Grid } from "@mui/material";
import ContentSection from "../../ContentSection";
import MxFormL3InputField from "@rf-l3/form/MxFormL3InputField";
import MxFormL3TextDateField from "@rf-l3/form/MxFormL3DatePickerField";
import useHasTrust from "../../hooks/useHasTrust";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import MxTypography from "@rf-l1/MxTypography";
import useValidateExplicitField from "../../hooks/useValidateExplicitField";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import { CValidationDocumentKeys } from "../../../../../../../util/model/documents-types";

function BuildingDeveloperOrPromotor() {
  const { HAS_TRUST_NO } = useHasTrust();
  const {
    validationDocuments: {
      company_assembly_act,
      enlarged_due_diligence,
      credit_bureau,
      company_rnc,
      commercial_register,
      construction_company_resume
    }
  } = useFormValidationsDocumentsMsgSlice();
  const { validateField } = useValidateExplicitField();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <ContentSection
      title="Constructora, Desarrollador o Promotor"
      tooltip="Constructora, Desarrollador o Promotor"
      color="blue"
      alert={
        company_assembly_act?.alert ||
        enlarged_due_diligence?.alert ||
        credit_bureau?.alert ||
        company_rnc?.alert ||
        commercial_register?.alert ||
        construction_company_resume?.alert
      }
    >
      <Grid container item xs={12} columnGap={2} rowGap={1}>
        {HAS_TRUST_NO && (
          <Grid item xs={12}>
            <Grid item xs={3}>
              <MxFormL3InputField
                withreacthookform={1}
                name={CPropertyValidationDocumentKeys.name_construction_company}
                label="Nombre de constructora"
              />
            </Grid>
          </Grid>
        )}

        {HAS_TRUST_NO && (
          <Grid container item xs={3}>
            <MxFormL4DocumentFileProperty
              withreacthookform={1}
              name={CPropertyValidationDocumentKeys.file_assembly_minutes}
              label="Documento de acta asamblea"
              maxSize={3}
              minSize={0}
              disabled={company_assembly_act?.disabled}
              typeKey={CValidationDocumentKeys.CompanyAssemblyAct}
            />
          </Grid>
        )}

        {HAS_TRUST_NO && (
          <Grid container item xs={3}>
            <MxFormL4DocumentFileProperty
              withreacthookform={1}
              name={CPropertyValidationDocumentKeys.file_due_diligence}
              label="Debida diligencia ampliada"
              maxSize={3}
              minSize={0}
              disabled={enlarged_due_diligence?.disabled}
              typeKey={CValidationDocumentKeys.EnlargedDueDiligence}
            />
          </Grid>
        )}

        {HAS_TRUST_NO && (
          <Grid container item xs={3}>
            <MxFormL4DocumentFileProperty
              withreacthookform={1}
              name={CPropertyValidationDocumentKeys.file_credit_bureau}
              label="Buró de crédito"
              maxSize={3}
              minSize={0}
              disabled={credit_bureau?.disabled}
              typeKey={CValidationDocumentKeys.CreditBureau}
            />
          </Grid>
        )}

        {HAS_TRUST_NO && (
          <Grid container item xs={3} rowGap={2}>
            <Grid item xs={12}>
              <MxFormL4DocumentFileProperty
                withreacthookform={1}
                name={CPropertyValidationDocumentKeys.file_rnc_construction}
                label="RNC de la constructora"
                maxSize={3}
                minSize={0}
                disabled={company_rnc?.disabled}
                typeKey={CValidationDocumentKeys.CompanyRnc}
              />
            </Grid>
            <Grid item xs={12}>
              <MxFormL3InputField
                withreacthookform={1}
                name={CPropertyValidationDocumentKeys.rnc_construction}
                label="RNC de la constructora"
                disabled={company_rnc?.disabled}
              />
            </Grid>
          </Grid>
        )}
        <Grid container item xs={3} rowGap={2}>
          <Grid item xs={12}>
            <MxFormL4DocumentFileProperty
              withreacthookform={1}
              name={CPropertyValidationDocumentKeys.file_commercial_register}
              label="Registro mercantil"
              maxSize={3}
              minSize={0}
              disabled={commercial_register?.disabled}
              typeKey={CValidationDocumentKeys.CommercialRegister}
            />
          </Grid>
          <Grid item xs={12}>
            <MxFormL3TextDateField
              withreacthookform={1}
              name={CPropertyValidationDocumentKeys.date_file_commercial_register}
              label="Fecha de emisión de el registro mercantil"
              disabled={commercial_register?.disabled}
            />
          </Grid>
        </Grid>
        <Grid container item xs={3}>
          <Grid item xs={12}>
            <MxFormL4DocumentFileProperty
              withreacthookform={1}
              name={CPropertyValidationDocumentKeys.file_construction_cv}
              label="CV de la constructora"
              maxSize={3}
              minSize={0}
              disabled={construction_company_resume?.disabled}
              typeKey={CValidationDocumentKeys.ConstructionCompanyResume}
            />
          </Grid>
        </Grid>
      </Grid>
    </ContentSection>
  );
}

export default BuildingDeveloperOrPromotor;
